export default __webpack_public_path__ + "static/media/quadStretch_concat.a2bae739.mp3";